/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import Checkbox from "@mui/material/Checkbox";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AppliedFilter from "../Reports/Components/AppliedFilter/AppliedFilter";
import styles from "../CaptureOnlineContribution/captureOnlinecontribution.styles";
import DateRangePicker from "../Reports/Components/DateRangePicker/DateRangePicker";
import OrganizationStructure from "../Reports/Components/OrganizationStructureNew/OrganizationStructure";
import Popover from "../Reports/Components/Popover/NewPopover";
import { SERVICES } from "../../components/Layout/Services";
import Loader from "../../components/Loader/Loader";
import SearchIconWithPeople from "../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../components/Svg/EmptyFile";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import { get, post } from "../../components/Layout/ApiHandler/apihandler";
import Button from "../../components/Layout/Button";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import NewTable from "../PendingOnlineContribution/Components/NewTable/NewTable";
import Pagination from "../../components/Layout/Pagination";
import InputField from "../../components/Layout/fieldInput/InputField";

const LOADER_DELAY = 1000;
const PAGE = "page";

const initialFormValue = {
  // dateOfBirthFrom: new Date(),
  // dateOfBirthTo: new Date(),
  year: new Date().getFullYear(),
};
function Form10BESearch() {
  const TITLE = "Form 10BE Search - BSG ContributionAdmin";
  const [searchData, setSearchData] = useState({});
  const [data, setData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [jumpPage, setJumpPage] = useState("");
  const [clearContributions, setClearContributions] = useState(false);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [selectedSortMethod, setSelectedSortMethod] = useState("");
  const [values, setValues] = useState({
    areaId: null,
    clusterId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });
  const [orgNames, setOrgNames] = useState({
    areaName: null,
    clusterName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  const [searchPerformed, setSearchPerformed] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [personalDetails, setPersonalDetails] = useState({
    memberIds: null,
    fullName: null,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const updateSortingMethod = (value) => {
  //   setSelectedSortMethod(value);
  // };
  const handlePersonalDetailsChange = (name, value) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  const [advancedSearchValues, setAdvancedSearchValues] = useState({
    selectedPayableCity: [],
    selectedPaymentMethod: [],
    selectedPaymentGateway: [],
    selectedUinType: [],
    selectedReceiptType: [],
  });
  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }
  const constructQueryParameters = (
    // formattedStartDate,
    // formattedEndDate,
    year,
    selectedSortMethod,
  ) => {
    const queryParams = [];
    const optionalParams = {
      areaId: values.areaId,
      clusterId: values.clusterId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
      blockId: values.blockId,
      // Add personal details
      memberIds: personalDetails.memberIds,
      memberName: personalDetails.fullName,
      // Add advanced search values
      payableCities: advancedSearchValues.selectedPayableCity.join(","),
      paymentMethodTypes: advancedSearchValues.selectedPaymentMethod.join(","),
      paymentGatewayTypes:
        advancedSearchValues.selectedPaymentGateway.join(","),
      uinTypes: advancedSearchValues.selectedUinType.join(","),
      receiptType: advancedSearchValues.selectedReceiptType.join(","),
      // id: dataEnetrdBy,
    };
    for (const key in optionalParams) {
      if (
        optionalParams[key] !== null &&
        optionalParams[key] !== undefined &&
        optionalParams[key] !== ""
      ) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    // if (
    //   moment(formattedStartDate, "YYYY-MM-DD", true).isValid() &&
    //   moment(formattedEndDate, "YYYY-MM-DD", true).isValid()
    // ) {
    //   queryParams.push(`from=${formattedStartDate}`);
    //   queryParams.push(`to=${formattedEndDate}`);
    // }
    // if (amountValue) {
    //   queryParams.push(`amount=${amountValue}`);
    // }
    // if (orderIdValue) {
    //   queryParams.push(`orderId=${orderIdValue}`);
    // }
    // if (dataEnetrdBy) {
    //   queryParams.push(`dataEnteredBy=${dataEnetrdBy}`);
    // }
    // if (selectedSortMethod) {
    //   queryParams.push(`sort=${selectedSortMethod}`);
    // }
    if (year) {
      queryParams.push(`contributionYear=${year}`);
    }
    return queryParams.join("&");
  };
  // const removeFilter = () => {
  //   setClearContributions(true);
  //   setSearchParams("");
  //   setPersonalDetails({
  //     memberId: null,
  //     fullName: null,
  //   });
  //   setTimeout(() => {
  //     setClearContributions(false);
  //     setSearchPerformed(false);
  //     // setShowFilter(false);
  //   }, 100);
  // };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!values.areaId) {
      toast.show("Please select Area", AlertStatus.ERROR);
      return;
    }
    setCurrentPage(0);
    setSearchPerformed(true);
    if (!initialAdvanceFormValue.year) {
      toast.show("Please select contribution year", AlertStatus.ERROR);
      return;
    }
    // const formattedStartDate = formatDateToYYYYMMDD(
    //   initialAdvanceFormValue.dateOfBirthFrom,
    // );
    // const formattedEndDate = formatDateToYYYYMMDD(
    //   initialAdvanceFormValue.dateOfBirthTo,
    // );
    try {
      setIsLoading(true);
      const url = `${SERVICES.FORM10BE_SEARCH}?${
        constructQueryParameters(initialAdvanceFormValue.year)
        // formattedStartDate,
        // formattedEndDate,
      }&page=${currentPage}&size=${pageSize}`;
      const response = await get(url);
      // console.log(response);
      if (response.ok) {
        const data = await response.json();
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSearchData(data.data);
        setData(data?.data?.content);
        const queryParams = constructQueryParameters(
          initialAdvanceFormValue.year,
        );
        // formattedStartDate,
        // formattedEndDate,
        // selectedSortMethod,
        const {
          areaId,
          clusterId,
          zoneId,
          regionId,
          chapterId,
          districtId,
          blockId,
        } = values;

        const {
          areaName,
          clusterName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          clusterId !== null && clusterName !== null && clusterName !== ""
            ? `clusterName=${clusterName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    // const formattedStartDate = moment(
    //   initialAdvanceFormValue.dateOfBirthFrom,
    // ).format("YYYY-MM-DD");
    // const formattedEndDate = moment(
    //   initialAdvanceFormValue.dateOfBirthTo,
    // ).format("YYYY-MM-DD");
    const queryParams = constructQueryParameters(
      // formattedStartDate,
      // formattedEndDate,
      initialAdvanceFormValue.year,
      // selectedSortMethod,
    );
    const {
      areaId,
      clusterId,
      zoneId,
      regionId,
      chapterId,
      districtId,
      blockId,
    } = values;

    const {
      areaName,
      clusterName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      blockName,
    } = orgNames;
    const orgParams = [
      areaId !== null && areaName !== null && areaName !== ""
        ? `areaName=${areaName}`
        : "",
      clusterId !== null && clusterName !== null && clusterName !== ""
        ? `clusterName=${clusterName}`
        : "",
      zoneId !== null && zoneName !== null && zoneName !== ""
        ? `zoneName=${zoneName}`
        : "",
      regionId !== null && regionName !== null && regionName !== ""
        ? `regionName=${regionName}`
        : "",
      chapterId !== null && chapterName !== null && chapterName !== ""
        ? `chapterName=${chapterName}`
        : "",
      districtId !== null && districtName !== null && districtName !== ""
        ? `districtName=${districtName}`
        : "",
      blockId !== null && blockName !== null && blockName !== ""
        ? `blockName=${blockName}`
        : "",
    ]
      .filter(Boolean)
      .join("&");
    try {
      const url = `${SERVICES.FORM10BE_SEARCH}?${queryParams}${
        orgParams ? `&${orgParams}` : ""
      }&page=${selectedPage}&size=${pageSize}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        // const filteredData = data?.data?.content.filter(
        //   (item) => item?.paymentOrder?.captureVerified !== true,
        // );
        setSearchData(data.data);
        setData(data?.data?.content);
        setSearchParams(
          `${queryParams}${
            orgParams ? `&${orgParams}` : ""
          }&page=${selectedPage}&size=${pageSize}`,
        );
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      queryParams.get(paramKey) && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };
  const onRemoveFilter = (filterKey) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete(filterKey);
    setSearchParams(updatedSearchParams.toString());
  };
  const onRemoveTwoFilter = (...filterKeys) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    filterKeys.forEach((key) => {
      updatedSearchParams.delete(key);
    });

    setSearchParams(updatedSearchParams.toString());
  };
  const convertTypeFormat = (type) => {
    const formattedType = type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return formattedType;
  };
  const getEntityTitlesForPaymentgatewayTypes = () => {
    return queryParams
      ?.get("paymentGatewayTypes")
      ?.split(",")
      ?.map((name) => name.trim());
  };
  const getEntityTitlesForPaymentmethodTypes = () => {
    return queryParams
      ?.get("paymentMethodTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForUinTypes = () => {
    return queryParams
      ?.get("uinTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForReceiptTypes = () => {
    return queryParams
      ?.get("receiptType")
      ?.split(",")
      ?.map((name) => name.trim());
  };

  const filters = [
    // org values
    renderAppliedFilter("areaId", "Area", searchParams.get("areaName"), () =>
      onRemoveTwoFilter("areaId", "areaName"),
    ),
    renderAppliedFilter(
      "clusterId",
      "Cluster",
      searchParams.get("clusterName"),
      () => onRemoveTwoFilter("clusterId", "clusterName"),
    ),
    renderAppliedFilter("zoneId", "Zone", searchParams.get("zoneName"), () =>
      onRemoveTwoFilter("zoneId", "zoneName"),
    ),
    renderAppliedFilter(
      "regionId",
      "Region",
      searchParams.get("regionName"),
      () => onRemoveTwoFilter("regionId", "regionName"),
    ),
    renderAppliedFilter(
      "chapterId",
      "Chapter",
      searchParams.get("chapterName"),
      () => onRemoveTwoFilter("chapterId", "chapterName"),
    ),
    renderAppliedFilter(
      "districtId",
      "District",
      searchParams.get("districtName"),
      () => onRemoveTwoFilter("districtId", "districtName"),
    ),
    renderAppliedFilter("blockId", "Block", searchParams.get("blockName"), () =>
      onRemoveTwoFilter("blockId", "blockName"),
    ),
    // Advance Search
    renderAppliedFilter(
      "paymentGatewayTypes",
      "Payment Gateway",
      getEntityTitlesForPaymentgatewayTypes()?.join(", "),
      () => onRemoveFilter("paymentGatewayTypes"),
    ),
    renderAppliedFilter(
      "paymentMethodTypes",
      "Payment Method",
      getEntityTitlesForPaymentmethodTypes()?.join(", "),
      () => onRemoveFilter("paymentMethodTypes"),
    ),
    renderAppliedFilter("amount", "Amount", searchParams.get("amount"), () =>
      onRemoveFilter("amount"),
    ),
    renderAppliedFilter(
      "contributionYear",
      "Contribution Year",
      searchParams.get("contributionYear"),
      () => onRemoveFilter("contributionYear"),
    ),
    renderAppliedFilter(
      "orderId",
      "Order Id",
      searchParams.get("orderId"),
      () => onRemoveFilter("orderId"),
    ),
    renderAppliedFilter(
      "uinTypes",
      "Uin Types",
      getEntityTitlesForUinTypes()?.join(", "),
      () => onRemoveFilter("uinTypes"),
    ),
    renderAppliedFilter(
      "receiptType",
      "Receipt Types",
      getEntityTitlesForReceiptTypes()?.join(", "),
      () => onRemoveFilter("receiptType"),
    ),
    renderAppliedFilter("sort", "Sorting", searchParams.get("sort"), () =>
      onRemoveFilter("sort"),
    ),
    // Personal Deatils
    renderAppliedFilter(
      "memberIds",
      "Member Id",
      searchParams.get("memberIds"),
      () => onRemoveFilter("memberIds"),
    ),
    renderAppliedFilter(
      "memberName",
      "Member Name",
      searchParams.get("memberName"),
      () => onRemoveFilter("memberName"),
    ),
    renderAppliedFilter(
      "from",
      "Date Range",
      `${moment(searchParams.get("from")).format("DD-MMM-YYYY")} - ${moment(
        searchParams.get("to"),
      ).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("from", "to"),
    ),
  ];
  useEffect(() => {
    // if (queryParams.get("amount") === null) {
    //   setAmountValue("");
    // }
    // if (queryParams.get("orderId") === null) {
    //   setOrderIdValue("");
    // }
    if (queryParams.get("memberIds") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        memberIds: "",
      }));
    }
    if (queryParams.get("memberName") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        fullName: "",
      }));
    }
    // if (queryParams.get("from") === null) {
    //   setInitialAdvanceFormValue((preValues) => ({
    //     ...preValues,
    //     dateOfBirthFrom: initialAdvanceFormValue?.dateOfBirthFrom,
    //     dateOfBirthTo: initialAdvanceFormValue?.dateOfBirthTo,
    //   }));
    // }
    if (queryParams.get("contributionYear") === null) {
      setInitialAdvanceFormValue((preValues) => ({
        ...preValues,
        year: initialAdvanceFormValue?.year,
      }));
    }
    if (queryParams.get("sort") === null) {
      setSelectedSortMethod("");
    }
  }, [
    queryParams.get("amount"),
    queryParams.get("orderId"),
    queryParams.get("memberIds"),
    queryParams.get("memberName"),
    clearContributions,
    // queryParams.get("from")
    queryParams.get("sort"),
  ]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [unselectedItems, setUnselectedItems] = useState([]);

  const handleSelectAllClick = () => {
    if (selectAll) {
      setSelectedItems([]);
      setUnselectedItems([]);
    } else {
      setSelectedItems(data.map((item) => item.paymentOrder?.id));
      setUnselectedItems([]);
    }
    setSelectAll(!selectAll);
  };
  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    handlePageChange(selectedPage.selected);
    // onPageChange(selectedPage.selected);
  };
  const pageCount = searchData.totalPages;
  const CAPTURE_ONLINE_CONTRIBUTION_COL = [
    {
      displayName: (
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAllClick}
          sx={{
            color: "white",
            "&.Mui-checked": {
              color: "white",
            },
          }}
        />
      ),
    },
    {
      displayName: "Member Id",
    },
    {
      displayName: "Member Name",
    },
    {
      displayName: "Division",
    },
    {
      displayName: "Conatct Info",
    },
    {
      displayName: "Org Structure",
    },
  ];
  const getCommonCellStyle = (index) => ({
    borderBottom: `1px solid ${index % 2 === 1 ? "#62B6DA" : "#ffff"}`,
    borderTop: `1px solid ${index % 2 === 1 ? "#62B6DA" : "#ffff"}`,
    textAlign: "left",
  });
  const toggleItemSelection = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
      setUnselectedItems([...unselectedItems, itemId]);
    } else {
      setSelectedItems([...selectedItems, itemId]);
      setUnselectedItems(unselectedItems.filter((id) => id !== itemId));
    }
  };
  const removeFilter = () => {
    setClearContributions(true);
    setShowAll(false);
    setSearchParams("");
    setSelectedItems([]);
    setUnselectedItems([]);
    setCurrentPage(0);
    setSelectAll(false);
    setPersonalDetails({
      memberIds: null,
      fullName: null,
    });
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
      // setShowFilter(false);
    }, 100);
  };
  const fetchData = async () => {
    if (showAll) {
      setIsLoading(true);
      setShowAll(true);
      // setCurrentPage(selectedPage);
      const formattedStartDate = moment(
        initialAdvanceFormValue.dateOfBirthFrom,
      ).format("YYYY-MM-DD");
      const formattedEndDate = moment(
        initialAdvanceFormValue.dateOfBirthTo,
      ).format("YYYY-MM-DD");
      const queryParams = constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedSortMethod,
      );
      const {
        areaId,
        clusterId,
        zoneId,
        regionId,
        chapterId,
        districtId,
        blockId,
      } = values;

      const {
        areaName,
        clusterName,
        zoneName,
        regionName,
        chapterName,
        districtName,
        blockName,
      } = orgNames;
      const orgParams = [
        areaId !== null && areaName !== null && areaName !== ""
          ? `areaName=${areaName}`
          : "",
        clusterId !== null && clusterName !== null && clusterName !== ""
          ? `clusterName=${clusterName}`
          : "",
        zoneId !== null && zoneName !== null && zoneName !== ""
          ? `zoneName=${zoneName}`
          : "",
        regionId !== null && regionName !== null && regionName !== ""
          ? `regionName=${regionName}`
          : "",
        chapterId !== null && chapterName !== null && chapterName !== ""
          ? `chapterName=${chapterName}`
          : "",
        districtId !== null && districtName !== null && districtName !== ""
          ? `districtName=${districtName}`
          : "",
        blockId !== null && blockName !== null && blockName !== ""
          ? `blockName=${blockName}`
          : "",
      ]
        .filter(Boolean)
        .join("&");
      try {
        const url = `${SERVICES.GET_MEMBER_SEARCH}?${queryParams}${
          orgParams ? `&${orgParams}` : ""
        }&pageSize=${searchData?.totalElements}`;
        const response = await get(url);

        if (response && response.ok) {
          const data = await response.json();
          // const filteredData = data?.data?.content.filter(
          //   (item) => item?.paymentOrder?.captureVerified !== true,
          // );
          setSearchData(data.data);
          setData(data?.data?.content);
          setSearchParams(
            `${queryParams}${orgParams ? `&${orgParams}` : ""}&pageSize=${10}`,
          );
        } else {
          console.error("Failed to fetch contribution data");
        }
      } catch (error) {
        Sentry.captureException(error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    } else {
      const formattedStartDate = formatDateToYYYYMMDD(
        initialAdvanceFormValue.dateOfBirthFrom,
      );
      const formattedEndDate = formatDateToYYYYMMDD(
        initialAdvanceFormValue.dateOfBirthTo,
      );
      try {
        setIsLoading(true);
        const url = `${SERVICES.GET_MEMBER_SEARCH}?${constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
          //   selectedSortMethod,
        )}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          // const filteredData = data?.data?.content.filter(
          //   (item) => item?.paymentOrder?.captureVerified !== true,
          // );
          setSearchData(data.data);
          setData(data?.data?.content);
          const queryParams = constructQueryParameters(
            formattedStartDate,
            formattedEndDate,
            // selectedSortMethod,
          );
          const {
            areaId,
            clusterId,
            zoneId,
            regionId,
            chapterId,
            districtId,
            blockId,
          } = values;

          const {
            areaName,
            clusterName,
            zoneName,
            regionName,
            chapterName,
            districtName,
            blockName,
          } = orgNames;
          const orgParams = [
            areaId !== null && areaName !== null && areaName !== ""
              ? `areaName=${areaName}`
              : "",
            clusterId !== null && clusterName !== null && clusterName !== ""
              ? `clusterName=${clusterName}`
              : "",
            zoneId !== null && zoneName !== null && zoneName !== ""
              ? `zoneName=${zoneName}`
              : "",
            regionId !== null && regionName !== null && regionName !== ""
              ? `regionName=${regionName}`
              : "",
            chapterId !== null && chapterName !== null && chapterName !== ""
              ? `chapterName=${chapterName}`
              : "",
            districtId !== null && districtName !== null && districtName !== ""
              ? `districtName=${districtName}`
              : "",
            blockId !== null && blockName !== null && blockName !== ""
              ? `blockName=${blockName}`
              : "",
          ]
            .filter(Boolean)
            .join("&");
          setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        }
      } catch (error) {
        Sentry.captureException(error);
        setIsLoading(false);
      }
    }
  };
  const handleSubmit = async () => {
    setIsLoading(true);
    const queryParams = new URLSearchParams(location.search);
    // const FromDateQueryParam = queryParams.get("from");
    // const fromDate = FromDateQueryParam
    //   ? moment(FromDateQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
    //   : "";
    // const ToDateQueryParam = queryParams.get("to");
    // const toDate = ToDateQueryParam
    //   ? moment(ToDateQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
    //   : "";

    // const uinTypeQueryParam = queryParams.get("uinTypes");
    // const uinTypes = uinTypeQueryParam
    //   ? uinTypeQueryParam.split(",").filter(Boolean)
    //   : [];
    // const paymentMethodQueryParam = queryParams.get("paymentMethodTypes");
    // const paymentMethodsTypes = paymentMethodQueryParam
    //   ? paymentMethodQueryParam.split(",").filter(Boolean)
    //   : [];
    // const paymentGatewayQueryParam = queryParams.get("paymentGatewayTypes");
    // const paymentGatewayTypes = paymentGatewayQueryParam
    //   ? paymentGatewayQueryParam.split(",").filter(Boolean)
    //   : [];
    let data;
    if (selectAll) {
      data = {
        // from: queryParams.get("from") || null,
        // to: queryParams.get("to") || null,
        // uinTypes: uinTypes || null,
        contributionYear: initialAdvanceFormValue.year,
        areaId: queryParams.get("areaId") || null,
        clusterId: queryParams.get("clusterId") || null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        memberIds: null,
        // paymentMethodType: paymentMethodsTypes || null,
        // paymentGatewayTypes: paymentGatewayTypes || null,
        // payableCities: null,
        // memberId: queryParams.get("memberId") || null,
        // fullName: queryParams.get("fullName") || null,
        // paymentOrderIds: [],
        // unselectedPaymentOrderIds: unselectedItems,
      };
    } else {
      data = {
        contributionYear: initialAdvanceFormValue.year,
        memberIds: selectedItems,
      };
    }
    const url = SERVICES.SEND_EMAIL;
    try {
      const response = await post(url, data);
      if (response.ok) {
        toast.show("Email Sent Successfully", AlertStatus.SUCCESS);
        // fetchData();
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getRows = (data) =>
    data.map((contInfo, index) => {
      const isSelected =
        (selectAll && !unselectedItems.includes(contInfo?.id)) ||
        selectedItems.includes(contInfo?.id);
      // contInfo?.paymentOrder?.captureVerified;

      const handleCheckboxClick = () => {
        toggleItemSelection(contInfo?.id);
      };
      return (
        <TableRow key={contInfo.id}>
          <TableCell sx={getCommonCellStyle(index)}>
            <Checkbox
              checked={isSelected}
              selected={isSelected}
              onClick={() => handleCheckboxClick()}
            />
          </TableCell>
          <TableCell
            sx={getCommonCellStyle(index)}
            style={{ minWidth: "7rem" }}
          >
            {contInfo?.id}
          </TableCell>
          <TableCell
            sx={getCommonCellStyle(index)}
            style={{ minWidth: "10rem" }}
          >
            {contInfo?.fullName || "NA"}
          </TableCell>
          <TableCell
            sx={getCommonCellStyle(index)}
            style={{ minWidth: "7rem" }}
          >
            {contInfo?.divisionName || "NA"}
          </TableCell>
          <TableCell
            sx={getCommonCellStyle(index)}
            style={{ minWidth: "10rem" }}
          >
            {contInfo?.mobileNumber || "NA"}
          </TableCell>
          <TableCell sx={getCommonCellStyle(index)}>
            {`${contInfo?.areaName || "NA"}/${contInfo?.clusterName || "NA"}/${
              contInfo?.zoneName || "NA"
            }/
            ${contInfo?.regionName || "NA"}/${contInfo?.chapterName || "NA"}
            /${contInfo?.districtName || "NA"}/${contInfo?.blockName || "NA"}`}
          </TableCell>
          {/* <TableCell sx={getCommonCellStyle(index)}>
            {moment(
              contInfo?.paymentOrder?.paymentTransaction?.receiptGeneratedAt,
            ).format("DD/MM/YYYY, h:mm:ss a") || "NA"}
          </TableCell> */}
          {/* <TableCell sx={getCommonCellStyle(index)}>
            {contInfo.orderNo || "NA"}
          </TableCell> */}
          {/* <TableCell sx={getCommonCellStyle(index)}>
            {contInfo?.paymentOrder?.amount}
          </TableCell>
          <TableCell sx={getCommonCellStyle(index)}>
            {contInfo.paymentOrder?.paymentTransaction?.externalReceiptNumber}
          </TableCell> */}
        </TableRow>
      );
    });
  useEffect(() => {
    if (!selectAll) {
      return;
    }
    if (selectAll) {
      const currentSelectedItems = data
        .map((item) => item?.id)
        .filter((id) => !unselectedItems.includes(id));

      setSelectedItems((prevSelectedItems) => [
        ...prevSelectedItems,
        ...currentSelectedItems,
      ]);
    } else {
      const currentUnselectedItems = data.map((item) => item?.id);

      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((id) => !currentUnselectedItems.includes(id)),
      );
    }
  }, [selectAll, data, unselectedItems]);

  // console.log("selectedItems", selectedItems);
  // console.log("SelectAll", selectAll);
  // console.log("Year", initialAdvanceFormValue.year);

  return (
    <div style={{ width: "100%", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Form 10BE Search" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Year"
                  views={["year"]}
                  name="monthFrom"
                  value={
                    initialAdvanceFormValue.year
                      ? dayjs(`${initialAdvanceFormValue.year}`)
                      : null
                  }
                  disableFuture
                  onChange={(newDate) => {
                    if (newDate) {
                      const selectedYear = newDate.year();
                      setInitialAdvanceFormValue({
                        ...initialAdvanceFormValue,
                        year: selectedYear,
                      });
                    }
                  }}
                  renderInput={(params) => <InputField {...params} />}
                />
              </LocalizationProvider>
              <Popover heading="Organization Structure" minWidth={413}>
                <OrganizationStructure
                  clearValues={clearContributions}
                  setNameValues={setOrgNames}
                  onUpdateValues={updateOrganizationStructureValues}
                  isAreaRequired
                />
              </Popover>
              <Popover
                heading="Personal Details"
                minWidth={300}
                minHeight={100}
              >
                <PersonalDetailsSearch
                  onDetailsChange={handlePersonalDetailsChange}
                  personalDetails={personalDetails}
                />
              </Popover>
              <Button type="submit">Search</Button>
            </form>
            <Button cancel onClick={removeFilter}>
              Reset
            </Button>
          </div>
          {searchPerformed && (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {filters.map((filter, index) => (
                  <>{filter}</>
                ))}
              </div>
            </div>
          )}
          <div style={styles.main}>
            {appliedFilters.length ? (
              <div style={styles.filterWrapper}>
                <div style={styles.filterContainer}>
                  {/* {appliedFilters.map((filter) => (
                    <AppliedFilter
                      key={filter.key}
                      filter={filter}
                      onRemove={onRemoveFilter}
                    />
                  ))} */}
                </div>
                {/* <div style={styles.clearAll} onClick={clearAllFilter}>
                  Clear
                </div> */}
              </div>
            ) : null}
            {!searchPerformed ? (
              <div style={styles.initialContent}>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </div>
            ) : data?.length > 0 ? (
              <div>
                {/* <GenericTable
                  tableData={data}
                  data={searchData}
                  headers={tableHeaders}
                  onPageChange={handlePageChange}
                /> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                    gap: "20px",
                  }}
                >
                  {/* <div /> */}
                  {/* <div>
                    <Button cancel onClick={handleShowAll}>
                      Show All
                    </Button>
                  </div> */}
                  {/* <div>
                    <ExportButton data={data} />
                  </div> */}
                </div>
                <NewTable
                  columns={CAPTURE_ONLINE_CONTRIBUTION_COL}
                  rows={getRows(data, toggleItemSelection, selectedItems)}
                  tableBodyTheme="#E8F6FC"
                />
                <Pagination
                  pageCount={pageCount}
                  onPageChange={handleChangePage}
                  forcePage={currentPage}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                    gap: "20px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Page Size */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>Rows per page:</span>

                    <select
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setCurrentPage(0);
                      }}
                      style={{
                        padding: "8px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {[5, 10, 20, 50, 100].map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Jump To Page */}
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>Jump to page:</span>

                    <input
                      type="number"
                      min={1}
                      max={pageCount}
                      value={jumpPage}
                      onChange={(e) => setJumpPage(e.target.value)}
                      style={{
                        width: "80px",
                        padding: "8px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />

                    <Button
                      onClick={() => {
                        const page = Number(jumpPage);

                        if (page > 0 && page <= pageCount) {
                          handlePageChange(page - 1);
                        }
                      }}
                    >
                      Go
                    </Button>
                  </div> */}
                </div>
                <ButtonContainer>
                  {/* <Button cancel>Cancel</Button> */}
                  <Button
                    onClick={handleSubmit}
                    disabled={!selectAll && selectedItems.length === 0}
                    style={{
                      opacity:
                        !selectAll && selectedItems.length === 0 ? 0.5 : 1,
                      cursor:
                        !selectAll && selectedItems.length === 0
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Submit
                  </Button>
                </ButtonContainer>
              </div>
            ) : (
              <div style={styles.initialContent}>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </div>
            )}
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}
export default Form10BESearch;

const ButtonContainer = styled.div`
  display: flex;
  padding: 24px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

// If we want to use AutoComplete Dropdown use commented Code otherwise use the above code
